import React from 'react'
import { faker } from '@faker-js/faker';
import { useEffect, useState } from 'react';
import { AllState } from '../data/FinancialData/AllState';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display:true,
    },
    title: {
      display: true,
      text: 'Chart.js Line Chart',
    },
  },
};

const labels = ['2012', '2013', '2014', '2015', '2016', '2017', '2018','2019','2020','2021','2022'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Jamu&Kashmir',
      data: labels.map(() => faker.datatype.number({ min: 1000, max: 65000 })),
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    {
      label: 'Punjab',
      data: labels.map(() => faker.datatype.number({ min: 1000, max: 65000 })),
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
    {
      label: 'Haryana',
      data: labels.map(() => faker.datatype.number({ min: 1000, max: 65000 })),
      borderColor: 'pink',
      backgroundColor: 'pink',
    },
    {
      label: 'Utrakhand',
      data: labels.map(() => faker.datatype.number({ min: 1000, max: 65000 })),
      borderColor: 'black',
      backgroundColor: 'black',
    },
    {
      label: 'Rajasthan',
      data: labels.map(() => faker.datatype.number({ min: 1000, max: 65000 })),
      borderColor: 'green',
      backgroundColor: 'green',
    },
    {
      label: 'UttarPardesh',
      data: labels.map(() => faker.datatype.number({ min: 1000, max: 65000 })),
      borderColor: 'orange',
      backgroundColor: 'orange',
    },
  ],
};
function LineChartGraph() {
  // useEffect(()=>{
  //   const fetchData=()=>{
  //     const url = "https://script.googleusercontent.com/macros/echo?user_content_key=mSgyf3UUwIGJMwE1KxdsctYlqNPev3wBnf8K6jfayE_0DFi_M0hYsYDiiOgZI5gd0f8yn35EZEpN46TbxoG3ZuKMjhk_YtVsm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnNSRJ-skaXASPa271zEfBUXmAQvlOApKFQH0butI3LPPQ0jiTj7s_Sjj82OUCpcSLg&lib=Max3KeHnmaz7pik5upeOOMJjhakhqkjmR"
  //     fetch(url,{
  //       method:'GET'
  //     }).then(data=>{
  //      console.log('API data',data)
  //      const res = data
  //      return res;
  //     }).catch(e=>{
  //       console.log('error',e)
  //     })
  //   }
  //   fetchData();
  // },[])
  return (
    <>
    <Line options={options} data={data}/>
    </>
  )
}

export default LineChartGraph